var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MovieGenreForm',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"items":_vm.items,"title":_vm.title,"type":_vm.type},on:{"getGenreDetail":_vm.getGenreDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }